webpackJsonp([20],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(63);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(7)("1cff5d4a", content, true);

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "./imgs/public_relation_bg_img_a.jpg?b72360527888dca29d5c9b1df8c6cf34";

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

var Vue = __webpack_require__(3);
var VueI18n = __webpack_require__(0);
Vue.use(VueI18n);

//import nls
var nls = __webpack_require__(4);
var defaultLocale = localStorage.getItem("defaultLocale");
if (defaultLocale == null) {
    defaultLocale = nls.defaultLocale;
}
var i18n = new VueI18n({
    locale: defaultLocale, // set locale
    messages : nls.text, // set locale messages
});

// 获取组件引用
// var testC = require('./components/App.vue');
var header_comp = __webpack_require__(2);
var body_comp = __webpack_require__(20);
var footer_comp = __webpack_require__(1);

window.vm = new Vue({
    i18n : i18n,  // VueI18n 插件
    el:"#app",
    components: {
        header_comp: header_comp,
        body_comp: body_comp,
        footer_comp: footer_comp
    }
});



/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(99),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


module.exports = {
    data: function () {
        return {
            testWording: "Hi Ivon is here~~"
        };
    },
    mounted: function () {

        $('#officePics-mobile').viewer({
            toolbar: false,
            navbar: false,
            title: false
        });

        $('#officePics-desktop').viewer({
            scalable: false,
            title: false,
            url: 'data-original'
        });
        window.pageTitle = {
            en_US: this.$i18n.messages.en_US.page_title_contact,
            zh_HK: this.$i18n.messages.zh_HK.page_title_contact,
            zh_CN: this.$i18n.messages.zh_CN.page_title_contact
        };
        window.setTitle(window.pageTitle[this.$i18n.locale]);
    }

};

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(5)();
// imports


// module
exports.push([module.i, "body,html{position:relative;height:100%;font-size:12px}body:after{background-image:url(" + __webpack_require__(14) + ")}.col-2-of-10{float:left;width:20%}.col-3-of-10{float:left;width:30%}.col-4-of-10{float:left;width:40%}.swiper-container{width:100%;height:100%}.box-size{height:150px;width:150px}.white-box-size{height:75px;width:375px;margin-top:50px}.title-size{font-size:14px}.content-size{font-size:12px}.bg-image{background-position:50%;background-size:cover;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (min-width:992px){.box-size{height:150px;width:150px}.white-box-size{height:75px;width:375px;margin-top:37.5px}.title-size{font-size:14px}.content-size{font-size:12px}}@media (min-width:1200px){.box-size{height:200px;width:200px}.white-box-size{height:100px;width:500px;margin-top:50px}.title-size{font-size:20px}.content-size{font-size:16px}}.officePhoneXs{background-color:#fff;padding:15px;margin:15px 0;width:100%;height:100%;box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}.xcx{display:block;width:100%;margin-top:20px}.xcx .box{float:left;width:50%}.xcx .box img{width:80%;margin:0 10%}.xcx .box h3{text-align:center;font-size:18px;font-weight:700}.tie{background-color:#fff;padding:40px 10px 10px 20px}@media (max-width:992px){.xcx .box{float:left;width:100%;margin-bottom:30px}.tie{padding:20px 0 10px}}", ""]);

// exports


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Contact_title")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tx-page-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("Contact_content")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "display": "inline-block",
      "background-color": "white",
      "padding": "15px",
      "margin-bottom": "100px",
      "border-right": "solid #e4ab34 10px",
      "box-shadow": "0 2px 4px rgba(0,0,0,0.50)"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "tie"
  }, [_c('div', {
    staticClass: "title-size",
    staticStyle: {
      "color": "#4A4A4A"
    }
  }, [_vm._v("\n                        " + _vm._s("联系地址：中国广州番禺区南站喜街") + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "content-size",
    staticStyle: {
      "color": "#9B9B9B"
    }
  }, [_vm._v("\n                        " + _vm._s("联系电话：020-88834737") + "\n                    ")]), _vm._v(" "), _vm._m(1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 col-lg-7",
    staticStyle: {
      "padding": "0px"
    },
    attrs: {
      "id": "officePics-desktop"
    }
  }, [_c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_1.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_2.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_3.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "col-xs-6",
    staticStyle: {
      "cursor": "pointer",
      "padding": "0px"
    },
    attrs: {
      "src": "imgs/x_4.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xcx"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "imgs/gzh_qr.jpg",
      "alt": "同熙商业公众号"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("同熙商业公众号")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('img', {
    attrs: {
      "src": "imgs/xcx_qr.jpg",
      "alt": "玩转喜街小程序"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("玩转喜街小程序")])])])
}]}

/***/ })

},[153]);


// WEBPACK FOOTER //
// js/contact.bundle.js?a3bdde5a923377333a32